import React, { useState, useEffect } from "react";
import useRouting from "../hooks/useRouting";
import usePageTracking from "../hooks/usePageTracking";
import { trackEvent } from "../utils/trackEvent";
import "./TreatmentDetails.css";

const TreatmentDetails = () => {
  const [selectedLoanType, setSelectedLoanType] = useState("");
  const [treatmentTiming, setTreatmentTiming] = useState("");
  const [treatmentType, setTreatmentType] = useState("");
  const [treatmentCost, setTreatmentCost] = useState("");
  const { navigateWithContext } = useRouting();

  // Track page visit
  usePageTracking("treatment-details");
  useEffect(() => { trackEvent("loan_treatment_details_viewed"); }, []);

  useEffect(() => {
    const loanType = localStorage.getItem("loanType");
    if (loanType) {
      setSelectedLoanType(loanType);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTreatmentTimingChange = (e) => {
    setTreatmentTiming(e.target.value);
  };

  const handleTreatmentTypeChange = (e) => {
    setTreatmentType(e.target.value);
  };

const formatIndianNumber = (value) => {
  if (!value) return "";

  // Remove all non-digits
  value = value.replace(/\D/g, "");

  // If only 3 or fewer digits → no formatting needed
  if (value.length <= 3) return value;

  // Split into last 3 digits + remaining numbers
  const lastThree = value.slice(-3);
  let rest = value.slice(0, -3);

  // Add commas every 2 digits for remaining part
  rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");

  return rest + "," + lastThree;
};


  // const handleCostChange = (e) => {
  //   const value = e.target.value.replace(/\D/g, ""); // Only allow digits
  //   setTreatmentCost(value);
  // };

const handleCostChange = (e) => {
  let raw = e.target.value.replace(/,/g, ""); // Remove commas
  let formatted = formatIndianNumber(raw);
  setTreatmentCost(formatted);
};



  

  const handleContinue = () => {
    trackEvent("loan_treatment_details_continue_clicked", {
      loan_type: selectedLoanType,
      treatment_timing: treatmentTiming,
      treatment_type: treatmentType,
    });
    if (selectedLoanType && treatmentTiming && treatmentType && treatmentCost) {
      localStorage.setItem(
        "treatmentDetails",
        JSON.stringify({
          loanType: selectedLoanType,
          timing: treatmentTiming,
          type: treatmentType,
          cost: treatmentCost,
        })
      );
      navigateWithContext("patient-info");
    }
  };

  const handleBack = () => {
    navigateWithContext("loan-type");
  };

  const isFormValid =
    selectedLoanType && treatmentTiming && treatmentType && treatmentCost;

  return (
    <div className="loan-container">
      <div className="header">
        <button className="back-button" onClick={handleBack}>
          ←
        </button>
        <div className="logo-container">
          <div className="logo">
            <span className="ayushpay">ayushpay</span>
            <span className="turtlemint">turtlemint+</span>
          </div>
        </div>
      </div>

      <div className="main-content">
        <div className="hero-section">
          <div className="hero-icon">🏥</div>
          <h1 className="hero-title">
            Help us understand
            <br />
            your need better
          </h1>
          <p className="hero-subtitle">
            So we can connect you to the
            <br />
            right care and financing options
          </p>
        </div>

        <div className="form-section">
          {/* Section 1: When is your treatment planned? */}
          <div className="form-group">
            <h2 className="section-title">When is your treatment planned?</h2>
            <div className="dropdown-container">
              <label className="dropdown-label">Treatment Planned *</label>
              <select
                className="custom-dropdown"
                value={treatmentTiming}
                onChange={handleTreatmentTimingChange}
              >
                <option value="">Choose the right option</option>
                <option value="1-week">1 Week</option>
                <option value="1-2-months">1 - 2 Months</option>
                <option value="treatment-ongoing">Ongoing</option>
                <option value="treatment-completed">Completed</option>
              </select>
            </div>
          </div>

          {/* Section 2: What treatment do you need? */}
          <div className="form-group">
            <h2 className="section-title">What treatment do you need?</h2>
            <div className="dropdown-container">
              <label className="dropdown-label">Disease <span className="text-red-500">*</span></label>
              <div className="searchable-dropdown">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Heart Arrhythmia"
                  value={treatmentType}
                  onChange={handleTreatmentTypeChange}
                />
                <div className="search-icon">🔍</div>
                <div className="dropdown-options">
                  <option value="">Select disease</option>
                  <div className="option">Cervical</div>
                  <div className="option">Dengue</div>
                  <div className="option">Gallstones</div>
                  <div className="option">Heart Arrhythmia</div>
                  <div className="option">Others</div>
                </div>
              </div>
            </div>
          </div>

          {/* Section 3: Treatment Cost */}
          <div className="form-group">
            <h2 className="section-title">Treatment Cost</h2>
            <div className="cost-input-container">
              <label className="dropdown-label">Enter Treatment Cost *</label>
              <div className="cost-input-wrapper">
                <span className="currency-symbol">₹</span>
               <input
  type="text"   // NOT number
  className="cost-input"
  value={treatmentCost}
  onChange={handleCostChange}
  placeholder="1,00,000"
/>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixed-button-container">
        <button
          className="continue-button"
          onClick={handleContinue}
          disabled={!isFormValid}
        >
          CONTINUE
        </button>
      </div>
    </div>
  );
};

export default TreatmentDetails;
